import * as React from "react";
import { RecommendationKind } from "../App";
import Recommendation from "./Recommendation";
import RecommendationService, {
	RecentActivity,
} from "../Helper/RecommendationService";
import { RecommendationCategories, RecommendationCategory } from "./Select";

export interface RecommendationsProps {
	theme: boolean;
	firstLoadCompleted?: () => void;
	context?: string;
}

export interface RecommendationState {
	tbsCategories: RecommendationCategories;
	qnaCategories: RecommendationCategories;
}

class Recommendations extends React.Component<
	RecommendationsProps,
	RecommendationState
> {
	static displayName = "Recommendations";
	loaded: boolean;

	constructor(props: RecommendationsProps) {
		super(props);
		this.loaded = false;
		this.state = {
			tbsCategories: null,
			qnaCategories: null,
		};
	}

	render() {
		let component: JSX.Element[] = [];

		if (this.props.context === "myTBS") {
			component.push(this.getTBSRecommendationWidget());
		} else if (this.props.context === "myQnA") {
			component.push(this.getQNARecommendationWidget());
		} else {
			component.push(this.getTBSRecommendationWidget());
			component.push(this.getQNARecommendationWidget());
		}

		return component;
	}

	getTBSRecommendationWidget() {
		if (this.state.tbsCategories && this.state.tbsCategories.selected) {
			return (
				<Recommendation
					key="TBS"
					theme={this.props.theme}
					loaded={this.loaded}
					kind={RecommendationKind.TBS}
					categories={this.state.tbsCategories}
					context={this.props.context}
				/>
			);
		}
	}

	getQNARecommendationWidget() {
		if (this.state.qnaCategories && this.state.qnaCategories.selected) {
			return (
				<Recommendation
					key="QNA"
					theme={this.props.theme}
					loaded={this.loaded}
					kind={RecommendationKind.QnA}
					categories={this.state.qnaCategories}
					context={this.props.context}
				/>
			);
		}
	}

	componentDidUpdate() {
		if (
			(this.state.tbsCategories || this.state.qnaCategories) &&
			!this.loaded &&
			typeof this.props.firstLoadCompleted === "function"
		) {
			this.loaded = true;
			this.props.firstLoadCompleted();
		}
	}

	async componentDidMount() {
		let recentActivityString = localStorage.getItem(
			"oc_study_recommendations_picker_data"
		);
		let recentActivity: RecentActivity;
		if (!recentActivityString) {
			recentActivity = await RecommendationService.fetchRecentActivity();
		} else {
			recentActivity = JSON.parse(recentActivityString);
			localStorage.removeItem("oc_study_recommendations_picker_data");
		}

		const tbsSelected =
			recentActivity.tbsSelectedIsbn13 && recentActivity.tbsSelectedGroupId
				? `${recentActivity.tbsSelectedIsbn13}:${recentActivity.tbsSelectedGroupId}`
				: null;
		const qnaSelected = recentActivity.qnaSubjectSelectedGroupId
			? recentActivity.qnaSubjectSelectedGroupId.toString()
			: null;
		this.setState({
			tbsCategories: {
				kind: RecommendationKind.TBS,
				selected: tbsSelected,
				items: recentActivity.tbs as RecommendationCategory[],
			},
			qnaCategories: {
				kind: RecommendationKind.QnA,
				selected: qnaSelected,
				items: recentActivity.qnaSubject as RecommendationCategory[],
			},
		});
	}
}

export default Recommendations;
